import moment from "moment";
export var MONTH_FORMAT = "MM-YYYY";
var MONTH_DISPLAY_FORMAT = "MMM YYYY";
export var monthsToSelection = function (months) {
    return months.map(function (month) { return ({
        value: month,
        inputDisplay: moment(month, MONTH_FORMAT).format(MONTH_DISPLAY_FORMAT),
    }); });
};
